/* BjerveUr: hover intent for the desktop header menus (spec 15.3).
   Opens after 150ms, closes after 250ms, so the pointer can travel between
   trigger and panel without the menu collapsing. Click, Escape and focus
   handling stay with Dawn's details/summary + details-disclosure code. */
(function () {
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 250;
  var desktop = window.matchMedia('(min-width: 990px)');
  var pointerHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function setExpanded(details, open) {
    var summary = details.querySelector('summary');
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
    var details = menu.querySelector('details');
    if (!details) return;
    var openTimer;
    var closeTimer;

    menu.addEventListener('mouseenter', function () {
      if (!desktop.matches || !pointerHover.matches) return;
      clearTimeout(closeTimer);
      if (details.hasAttribute('open')) return;
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (other) {
          if (other !== details) setExpanded(other, false);
        });
        setExpanded(details, true);
      }, OPEN_DELAY);
    });

    menu.addEventListener('mouseleave', function () {
      if (!desktop.matches || !pointerHover.matches) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (menu.contains(document.activeElement)) return;
        if (details.hasAttribute('open')) setExpanded(details, false);
      }, CLOSE_DELAY);
    });
  });
})();
